/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, reset } from 'redux-form'

import { Form, FormButtonGroup } from 'components/forms'
import { SaveButton } from 'components/buttons'
import { ModalFooter } from 'components/modal'
import { createValidator } from 'lib/form-validation'

import { getShippingAddress, getUserFullName } from 'registry/reducers'
import { saveShippingAddress, setActiveModal } from 'registry/actions'

import { COUNTRIES, STATES_AND_PROVINCES } from 'shared/constants'
import * as blUrls from 'lib/urls'
import { connect } from 'react-redux'
import ShippingFields, { createValidationRules } from './shipping-fields'

class ShippingAddressForm extends React.Component {
  static propTypes = {
    fields: PropTypes.shape({
      city: PropTypes.object,
      country: PropTypes.object,
      name: PropTypes.object,
      phone: PropTypes.object,
      state: PropTypes.object,
      streetAddress1: PropTypes.object,
      streetAddress2: PropTypes.object,
      zip: PropTypes.object,
    }),
    submitting: PropTypes.bool,
    handleSubmit: PropTypes.func,
    onSubmitSuccess: PropTypes.func,
    onSubmitFail: PropTypes.func,
    showCancelButton: PropTypes.bool.isRequired,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    cancelText: PropTypes.string,
    renderSubText: PropTypes.func,
    excludedFields: PropTypes.arrayOf(PropTypes.string),
    ctaSectionClassName: PropTypes.string,
    secondaryButtonComponent: PropTypes.func,
  }

  render() {
    const {
      fields,
      handleSubmit,
      showCancelButton,
      submitting,
      onSave,
      onCancel,
      cancelText,
      renderSubText,
      excludedFields,
      ctaSectionClassName,
      secondaryButtonComponent,
    } = this.props

    return (
      <Form onSubmit={handleSubmit(onSave)}>
        <ShippingFields
          {...fields}
          countries={COUNTRIES}
          states={STATES_AND_PROVINCES}
          excludedFields={excludedFields}
        />
        <ModalFooter>
          {showCancelButton ? (
            <FormButtonGroup
              onClickSecondary={onCancel}
              secondaryButtonDisabled={submitting}
              textPrimary="Save"
              textSecondary={cancelText ? cancelText : undefined}
              className={ctaSectionClassName}
              secondaryButtonComponent={secondaryButtonComponent}
            />
          ) : (
            <SaveButton submitting={submitting} pill />
          )}
        </ModalFooter>
        {renderSubText && renderSubText()}
      </Form>
    )
  }
}

const DecoratedComponent = connect()(ShippingAddressForm)

export default reduxForm(
  {
    form: 'shippingAddressForm',
    fields: [
      'city',
      'country',
      'name',
      'phone',
      'state',
      'streetAddress1',
      'streetAddress2',
      'zip',
    ],
    validate: createValidator(createValidationRules()),
  },
  (state, props) => {
    const address = props.address || getShippingAddress(state) || {}

    return {
      initialValues: {
        city: address.city,
        country: address.country || 'United States',
        name: address.name || getUserFullName(state),
        phone: address.phone,
        state: address.state,
        streetAddress1: address.streetAddress1,
        streetAddress2: address.streetAddress2,
        zip: address.zip,
      },
    }
  }
)(DecoratedComponent)
